import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FiLogOut } from "react-icons/fi"; // Icono de logout
import "./Layout.css"; // Importar estilos

const Layout = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);

    // Cargar usuario desde localStorage al iniciar el componente
    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            try {
                setUser(JSON.parse(storedUser));
            } catch (error) {
                console.error("❌ Error al parsear el usuario almacenado:", error);
                handleLogout();
            }
        } else {
            console.warn("🔴 No hay usuario, redirigiendo a login...");
            forceRedirect("/login");
        }
    }, []);

    // Función para forzar la redirección a login
    const forceRedirect = (path) => {
        console.log(`🔄 Redirigiendo a ${path}...`);
        navigate(path, { replace: true });
        setTimeout(() => {
            if (window.location.pathname !== path) {
                console.log("⚠️ navigate() falló, usando window.location.href...");
                window.location.href = path;
            }
        }, 300);
    };

    const handleLogout = () => {
        console.log("🛑 Cerrando sesión...");
        localStorage.removeItem("user"); // Eliminar usuario
        setUser(null);
        forceRedirect("/login");
    };

    return (
        <div className="d-flex flex-column min-vh-100">
            {/* Navbar superior */}
            <Navbar className="navbar-custom" expand="lg">
                <Container>
                    <Navbar.Brand as={Link} to="/">Mixta 39</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link as={Link} to="/">Inicio</Nav.Link>
                            <Nav.Link as={Link} to="/profesores">Profesores</Nav.Link> {/* Nuevo enlace para Profesores */}
                            <Nav.Link as={Link} to="/estudiantes">Estudiantes</Nav.Link>
                            <Nav.Link as={Link} to="/asistencia">Asistencia</Nav.Link>
                            <Nav.Link as={Link} to="/reportes">Reportes</Nav.Link>
                            <Nav.Link as={Link} to="/administration">Administracion</Nav.Link>
                        </Nav>
                        <Nav className="d-flex align-items-center">
                            {user ? (
                                <>
                                    <Navbar.Text className="me-3 text-light">Hola, {user.email}</Navbar.Text>
                                    <FiLogOut 
                                        size={24} 
                                        color="white"
                                        onClick={handleLogout} 
                                        style={{ cursor: "pointer" }} 
                                        title="Cerrar sesión"
                                    />
                                </>
                            ) : (
                                <Nav.Link as={Link} to="/login">Iniciar Sesión</Nav.Link>
                            )}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            {/* Contenido de la página */}
            <Container className="mt-4 flex-grow-1">
                <Outlet />
            </Container>

            {/* Footer */}
            <footer className="footer-custom mt-auto">
                <Container>
                    <p className="mb-0">© {new Date().getFullYear()} Mixta 39 | Todos los derechos reservados</p>
                </Container>
            </footer>
        </div>
    );
};

export default Layout;
